const swiper14 = new Swiper('.announcement-main', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 3,
    navigation: {
        nextEl: '.swipers-button-nexts',
        prevEl: '.swipers-button-prevs',
    },
    breakpoints: {
        2560:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1024:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1440:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        426:{
            slidesPerView: 1,
            spaceBetween: 15,
        },
        375:{
          slidesPerView: 1,
          spaceBetween: 15,
        },
      320:{
          slidesPerView: 1,
          spaceBetween: 15,
        }
    }
})
